import { Pipe, PipeTransform } from '@angular/core';
import { CheckCircle2, CircleDot, Clock3, LucideIconData } from 'lucide-angular';

/** Project status values supported by badge styling, with fallback strings allowed. */
export type ProjectStatus = 'Active' | 'In Progress' | 'Completed' | string;

/**
 * Maps a project workflow status to the Tailwind classes used by status badges.
 */
@Pipe({ name: 'statusBadge', standalone: true })
export class StatusBadgePipe implements PipeTransform {
  /**
   * Returns the badge classes for a project status.
   *
   * @param status Project status displayed in list and detail views.
   * @returns Tailwind class string for the status badge.
   */
  transform(status: ProjectStatus): string {
    switch (status) {
      case 'Active':      return 'bg-talos-accent/7 text-talos-accent';
      case 'In Progress': return 'bg-talos-ink/7 text-talos-ink';
      case 'Completed':   return 'bg-talos-ink/7 text-talos-ink';
      default:            return 'bg-talos-ink/7 text-talos-ink';
    }
  }
}

/**
 * Maps a project workflow status to its badge icon.
 */
@Pipe({ name: 'statusBadgeIcon', standalone: true })
export class StatusBadgeIconPipe implements PipeTransform {
  /**
   * Returns the Lucide icon for a project status.
   *
   * @param status Project status displayed in list and detail views.
   */
  transform(status: ProjectStatus): LucideIconData {
    switch (status) {
      case 'Active':      return CircleDot;
      case 'In Progress': return Clock3;
      case 'Completed':   return CheckCircle2;
      default:            return CircleDot;
    }
  }
}
